'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.historyDataForThread = undefined;

var _reselect = require('reselect');

var _getters = require('conversations-internal-schema/async-data/operators/getters');

var _historyForThread = require('./historyForThread');

var _isPersistedThread = require('../operators/isPersistedThread');

var _getStubbedThreadHistory = require('../../stubbed-thread-history/selectors/getStubbedThreadHistory');

var _threadFromProps = require('../../threads/selectors/threadFromProps');

var historyDataForThread = exports.historyDataForThread = (0, _reselect.createSelector)([_historyForThread.historyForThread, _threadFromProps.threadFromProps, _getStubbedThreadHistory.getStubbedThreadHistory], function (history, thread, stubbedThreadHistory) {
  if (!(0, _isPersistedThread.isPersistedThread)(thread)) {
    return stubbedThreadHistory;
  }

  return (0, _getters.getData)(history);
});


//////////////////
// WEBPACK FOOTER
// ./js/thread-histories/selectors/historyDataForThread.js
// module id = 44
// module chunks = 2 3